import { useEffect, useState, useRef } from 'react'
import { AnimatePresence } from 'framer-motion'
import SVG from 'react-inlinesvg'

import { useTheme } from '../../lib/hooks'
import { CheckoutBody, CheckoutLogo, CheckoutProvider, CheckoutWrapper } from './Checkout.styles'
import Cart from './components/Cart'
import Confirmation from './components/Confirmation'
import Payment from './components/Payment'
import useCheckout from './hooks/useCheckout'

const Checkout = () => {
  const { currentStep } = useCheckout()
  const themes = useTheme()
  const paymentProvider = window.BtDevice?.getPaymentProviderLogo() || process.env.REACT_APP_PAYMENT_PROVIDER || undefined
  const [clickCount, setClickCount] = useState(0)
  const clickTimerRef = useRef(null)

  useEffect(() => {
    const simulateScanning = sessionStorage.getItem('simulateScanning')
    console.log('[Checkout] simulateScanning parameter value: ' + simulateScanning)

    if (simulateScanning === 'true') {
      console.log('Simulate scanning random products')
      setTimeout(() => {
        const random = Math.floor(Math.random() * 8) + 1
        window.BtApp.handleQrReader('1234' + random)
      }, 1500)
      setTimeout(() => {
        const random = Math.floor(Math.random() * 8) + 1
        window.BtApp.handleQrReader('1234' + random)
      }, 2000)
    }
  }, [])

  const handleLogoClick = () => {
    setClickCount(prev => prev + 1)
    
    if (clickTimerRef.current) {
      clearTimeout(clickTimerRef.current)
    }
    
    clickTimerRef.current = setTimeout(() => {
      setClickCount(0)
    }, 3000)
    
    if (clickCount + 1 === 5) {
      if (window.BtDevice && window.BtDevice.clearSettings) {
        window.BtDevice.clearSettings()
        console.log('BtDevice settings cleared')
      }
      setClickCount(0)
      clearTimeout(clickTimerRef.current)
    }
  }

  return (
    <AnimatePresence>
      <CheckoutWrapper>
        <CheckoutLogo>
          {themes.assets.logo && <SVG src={themes.assets.logo}></SVG>}
          {themes.assets.logoJpg && <img src={themes.assets.logoJpg} alt='logo' ></img>}
          {themes.additionalInfo && (
            <div style={{ 
              marginTop: '0.75rem', 
              textAlign: 'center',
              fontSize: '0.8rem',
              color: '#666'
            }}>
              <p style={{ margin: '0 0 0.3rem 0' }}>{themes.additionalInfo.text}</p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '1rem',
                fontWeight: '500',
                color: themes.colors.global,
                fontSize: '0.85rem'
              }}>
                {themes.additionalInfo.links.map((link, index) => (
                  <span key={index}>{link}</span>
                ))}
              </div>
            </div>
          )}
        </CheckoutLogo>
        <CheckoutBody>
          {currentStep === 'CART' && <Cart key="CART" />}
          {currentStep === 'PAYMENT' && <Payment key="PAYMENT" />}
          {currentStep === 'CONFIRMATION' && <Confirmation key="CONFIRMATION" />}
        </CheckoutBody>
        {paymentProvider && (
          <CheckoutProvider>
            Powered by
            <img src={`/img/payments/${paymentProvider}.svg`} alt="" onClick={handleLogoClick} />
          </CheckoutProvider>
        )}
      </CheckoutWrapper>
    </AnimatePresence>
  )
}

export default Checkout
